import { ToastHelper } from "../../assets/js/helpers/toast";
import { Translation } from "../../assets/js/helpers/translation";

export class FilterSearch {

  inputSelector = "[data-filter-input]";
  filterSubmitBarSelector = "[data-filter-submit-bar]";
  formSelector = "[data-filter-form]";
  clearFilterBtnSelector = "[data-clear-filter]";
  submitBtnSelector = "[data-submit-filter]";
  orderBySelector = "[data-orderby]";
  orderByFieldSelector = "[data-order-results]";
  orderByField = null;
  submitBtn = null;
  clearFiltersBtn = null;

  constructor(el = null) {
    this.el = el;
    var filterSubmitBar = this.el.querySelector(this.filterSubmitBarSelector);
    this.submitBtn = filterSubmitBar.querySelector(this.submitBtnSelector);
    this.clearFiltersBtn = filterSubmitBar.querySelector(this.clearFilterBtnSelector);
    //this.orderByField = this.el.querySelector(this.orderByFieldSelector);
    this.init();
  }
  
  clearFilters(){
    this.el.querySelectorAll( this.inputSelector ).forEach( (element) => {
      if( element.tagName !== "SELECT" ){
        if( element.type == "checkbox" ){
          element.checked = false;
        }else{
          element.value = "";
        }
      }
    });
  }

  sendForm(){
    this.el.querySelector(this.formSelector).submit();
  }

  init() {
    /*
    this.clearFiltersBtn.addEventListener("click", (event) => {
      this.clearFilters();
    });
    */
    /*
    this.el.querySelectorAll( this.orderBySelector ).forEach( element => {
      element.onchange = (e) => {
        this.orderByField.value = element.value;
        this.submitBtn.click();
      }; 
    });
    */
  }

}
